var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"result-list-tab-menu"}},_vm._l((_vm.entityTypes),function(type,index){return _c('div',{key:index,staticClass:"menu-tab",class:{selected: type === _vm.entityType},on:{"click":function($event){return _vm.$emit('entity-type-changed', type)}}},[_vm._v(_vm._s(_vm._f("searchTabTranslate")(type)))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }